import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = {
  class: "flex",
  id: "cv"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "items" }
const _hoisted_4 = { class: "item" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "social" }
const _hoisted_7 = { class: "me" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ic = _resolveComponent("ic")!
  const _component_TShaped = _resolveComponent("TShaped")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[3] || (_cache[3] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_ic, { icon: "earth-americas" }),
              _createElementVNode("div", {
                innerHTML: _ctx.personal.home.format()
              }, null, 8, _hoisted_5)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: "item",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.mailme()))
            }, [
              _createVNode(_component_ic, { icon: "paper-plane" })
            ]),
            _createElementVNode("div", {
              class: "item brand",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.github()))
            }, [
              _createVNode(_component_ic, { icon: "fa-brands fa-github" })
            ]),
            _createElementVNode("div", {
              class: "item",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.linkedin()))
            }, [
              _createVNode(_component_ic, { icon: "fa-brands fa-linkedin" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('cv.bio')), 1)
      ])
    ]),
    _createVNode(_component_TShaped)
  ], 64))
}